module.exports = __webpack_public_path__ + "img/retakeCam.932cb861.svg";